import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DnCheckboxComponent } from './dn-checkbox.component';
import { MatCheckboxModule } from '@angular/material/checkbox';

@NgModule({
  declarations: [DnCheckboxComponent],
  imports: [CommonModule, MatCheckboxModule],
  exports: [DnCheckboxComponent],
})
export class DnCheckboxModule {}
